class StoreReviews extends HTMLElement {
    constructor() {
        super();

        this.apiUrl = this.dataset.apiUrl || ncol_api_url;

        this.element = {
            storeBrand: this.querySelector("[data-store-brand]"),
            storeBrandName: this.querySelector("[data-store-brand-name]"),
            storeName: this.querySelector("[data-store-name]"),
            fbLink: this.querySelector("[data-fb-link]"),
            googleLink: this.querySelector("[data-google-link]")
        };

        this.setupFbLink();
        this.getSelectedStore();
    }

    setupFbLink() {
        // get user agent
        let userAgent = navigator.userAgent || navigator.vendor || window.opera;
        userAgent = userAgent.toLowerCase();

        this.element.fbLink.addEventListener("click", (e) => {
            if (userAgent.includes("iphone") || userAgent.includes("ipad")) {
                try {
                    window.location.href = "fb://profile/175724255774159";
                    e.preventDefault();
                    return;
                } catch (error) {}
            } else if (userAgent.includes("android")) {
                try {
                    window.location.href = "fb://page/175724255774159";
                    e.preventDefault();
                    return;
                } catch (error) {}
            }
        });
    }

    getSelectedStore() {
        const path = window.location.pathname;
        this.storeId = path.replace(/\/$/, "").split("/").pop();

        if (this.storeId) this.getStoreData();
        else this.showStoreDetails();
    }

    async getStoreData() {
        try {
            // Get store locations.
            const fetchRes = await fetch(`${this.apiUrl}/public/api/locations.json`);
            const data = await fetchRes.json();
            this.stores = data.stores;
            this.selectedStore = this.stores.find((store) => store.id === this.storeId);
        } catch (e) {
            console.error(e);
        }

        this.showStoreDetails();
    }

    showStoreDetails() {
        if (!this.selectedStore) {
            this.element.storeBrand.remove();
            this.element.storeName.remove();
            this.element.googleLink.remove();
            return;
        }

        if (this.selectedStore.name.includes("Quarks")) this.selectedStore.brand = "Quarks";
        else if (this.selectedStore.name.includes("Urban Trail")) this.selectedStore.brand = "Urban Trail";
        this.selectedStore.shortName = this.selectedStore.name.replace(/(Quarks|Urban Trail) - /, "");

        this.element.storeBrand.textContent = this.selectedStore.brand;
        let brandClassName = this.selectedStore.brand.toLowerCase();
        if (brandClassName === "urban trail") brandClassName = "urban-trail";
        this.element.storeBrand.classList.add(`store-reviews__brand--${brandClassName}`);
        this.element.storeName.textContent = this.selectedStore.shortName;
        this.element.googleLink.href = this.selectedStore.google_review_url;

        this.element.storeBrandName.textContent = this.selectedStore.brand;
    }
}

customElements.define("store-reviews", StoreReviews);
